(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["racewax-kit-finder"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('racewax-kit-finder')) {
  customElements.define('racewax-kit-finder', class extends HTMLElement {
    connectedCallback() {
      if(this.initialized)return;
      this.initialized=true;
      const decode=value=>{
        if(typeof value==='string'){const el=document.createElement('textarea');el.innerHTML=value;return el.value;}
        if(Array.isArray(value))return value.map(decode);
        if(value&&typeof value==='object')return Object.fromEntries(Object.entries(value).map(([k,v])=>[k,decode(v)]));
        return value;
      };
      const copy=decode(JSON.parse(this.querySelector('[data-rwkf-copy]').textContent));
      const {experiences:Xi,jobs:Zi,kits:Qi}=copy;
      function $i(e,t,n=`standard`){if(!Xi.some(t=>t.id===e))throw Error(copy.messages.m0);if(!Array.isArray(t)||!t.length)throw Error(copy.messages.m1);if(t.some(e=>!Zi.some(t=>t.id===e))||new Set(t).size!==t.length)throw Error(copy.messages.m2);if(n!==`standard`&&n!==`digital`)throw Error(copy.messages.m3);return{experience:e,selected:t,eliteIron:n}}function ea(e,t,n=`standard`){let r=$i(e,t,n),i=Zi.filter(e=>r.selected.includes(e.id)),a=Math.max(...i.map(e=>e.minimum)),o=a,s=``;a===0&&r.experience!==`beginner`&&r.selected.includes(`sharpen`)?(o=1,s=copy.messages.m4):a===2&&r.experience===`experienced`&&r.selected.includes(`bevel`)?(o=3,s=copy.messages.m5):s=r.experience===`beginner`?copy.messages.m6:copy.messages.m7;let c=r.experience===`beginner`&&o>=2?copy.messages.m8:``,l=o===3?copy.messages.m9:``,u=Qi.find(e=>e.id===`digital-elite`),d=o===2&&r.eliteIron===`digital`?u:Qi.find(e=>e.capabilityRank===o),f=Qi.findIndex(e=>e.id===d.id),p=Qi.find(e=>e.capabilityRank===o-1)??null,m=Qi.find(e=>e.capabilityRank===o+1)??null,h=i.filter(e=>e.minimum>o-1).map(e=>e.title),g=p?.id===`elite`?u:null,_=m?.id===`elite`?u:null,v=o===2?r.eliteIron===`digital`?copy.messages.m10:copy.messages.m11:``;return{index:f,capabilityRank:o,kit:d,chosen:i,experience:r.experience,eliteIron:r.eliteIron,experienceReason:s,learningNote:c,angleNote:l,configurationNote:v,simpler:p,advanced:m,simplerVariant:g,advancedVariant:_,simplerMissing:h}}

      const l=copy.labels, app=this.querySelector('[data-rwkf-app]');
      const esc=s=>String(s??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
      const root=this.dataset.root.replace(/\/$/,'');
      const href=k=>root+k.href;
      const id='rwkf-'+this.closest('[id]')?.id;
      app.innerHTML=`<header class="rwkf-intro"><p class="rwkf-eyebrow">${esc(l.eyebrow)}</p><h2>${esc(l.title)}</h2><p>${esc(l.intro)}</p></header>
      <div class="rwkf-layout"><form novalidate>
      <fieldset><legend><span>01</span> ${esc(l.experience)}</legend><p>${esc(l.experienceHint)}</p><div class="rwkf-experiences">${Xi.map(e=>`<label class="rwkf-choice"><input type="radio" name="experience" value="${e.id}" aria-describedby="${id}-experience-error"><span><strong>${esc(e.title)}</strong><small>${esc(e.detail)}</small></span></label>`).join('')}</div><p id="${id}-experience-error" class="rwkf-error" hidden></p></fieldset>
      <fieldset><legend><span>02</span> ${esc(l.jobs)}</legend><p>${esc(l.jobsHint)}</p><div class="rwkf-jobs">${Zi.map(e=>`<label class="rwkf-choice"><input type="checkbox" name="job" value="${e.id}" aria-describedby="${id}-jobs-error"><span><strong>${esc(e.title)}</strong><small>${esc(e.detail)}</small></span></label>`).join('')}</div><p id="${id}-jobs-error" class="rwkf-error" hidden></p></fieldset>
      <fieldset class="rwkf-iron" hidden><legend>${esc(l.iron)}</legend><p>${esc(l.ironHint)}</p><div class="rwkf-irons"><label class="rwkf-choice"><input type="radio" name="iron" value="standard" checked><span>${esc(l.standard)}</span></label><label class="rwkf-choice"><input type="radio" name="iron" value="digital"><span>${esc(l.digital)}</span></label></div></fieldset>
      <div class="rwkf-actions"><button type="submit" class="rwkf-button">${esc(l.submit)} <span aria-hidden="true">→</span></button><button type="reset" class="rwkf-reset">${esc(l.reset)}</button></div></form>
      <div class="rwkf-result" tabindex="-1" aria-live="polite" aria-atomic="true"><div class="rwkf-placeholder"><h3>${esc(l.waiting)}</h3><p>${esc(l.waitingHint)}</p></div></div></div>
      `;
      const form=app.querySelector('form'), result=app.querySelector('.rwkf-result');
      let submitted=false;
      const state=()=>({experience:form.querySelector('[name=experience]:checked')?.value,jobs:Array.from(form.querySelectorAll('[name=job]:checked'),e=>e.value),iron:form.querySelector('[name=iron]:checked')?.value||'standard'});
      const card=(k,title,extra='')=>k?`<article class="rwkf-alternative"><p class="rwkf-eyebrow">${esc(title)}</p><h4>${esc(k.name)}</h4><p>${esc(k.upgrade)}</p>${extra}<a href="${esc(href(k))}">${esc(l.view)} <span aria-hidden="true">→</span></a></article>`:'';
      const update=()=>{
        const s=state();
        const r=s.experience&&s.jobs.length?ea(s.experience,s.jobs,s.iron):null;
        app.querySelector('.rwkf-iron').hidden=r?.capabilityRank!==2;
        app.querySelectorAll('.rwkf-choice').forEach(e=>e.classList.toggle('is-selected',e.querySelector('input').checked));
        if(!submitted||!r)return;
        result.innerHTML=`<article class="rwkf-match"><p class="rwkf-eyebrow">${esc(l.match)}</p><h3>${esc(r.kit.name)}</h3><p class="rwkf-tagline">${esc(r.kit.tagline)}</p><p>${esc(r.kit.summary)}</p><h4>${esc(l.why)}</h4><p>${esc(r.experienceReason)}</p><h4>${esc(l.covers)}</h4><ul>${r.chosen.map(j=>`<li>${esc(j.title)}</li>`).join('')}</ul><h4>${esc(l.limits)}</h4><p>${esc(r.kit.limitation)}</p>${[r.configurationNote,r.learningNote,r.angleNote].filter(Boolean).map(n=>`<p class="rwkf-note">${esc(n)}</p>`).join('')}<a class="rwkf-button" href="${esc(href(r.kit))}">${esc(l.shop)} <span aria-hidden="true">→</span></a></article>
        <div class="rwkf-alternatives">${card(r.simpler,l.simpler,r.simplerMissing.length?`<p class="rwkf-missing">${esc(l.misses)} ${esc(r.simplerMissing.join(', '))}</p>`:'')}${card(r.advanced,l.advanced)}</div>`;
        app.querySelectorAll('[data-kit]').forEach(e=>e.classList.toggle('is-recommended',e.dataset.kit===r.kit.id));
      };
      const error=(type,message)=>{
        const p=app.querySelector('#'+CSS.escape(id+'-'+type+'-error'));p.textContent=message;p.hidden=!message;
        form.querySelectorAll(type==='experience'?'[name=experience]':'[name=job]').forEach(e=>e.setAttribute('aria-invalid',String(!!message)));
      };
      form.addEventListener('change',()=>{
        const s=state();if(s.experience)error('experience','');if(s.jobs.length)error('jobs','');
        if(submitted&&(!s.experience||!s.jobs.length)){submitted=false;result.innerHTML=`<div class="rwkf-placeholder"><h3>${esc(l.waiting)}</h3><p>${esc(l.waitingHint)}</p></div>`;app.querySelectorAll('[data-kit]').forEach(e=>e.classList.remove('is-recommended'));}
        update();
      });
      form.addEventListener('submit',e=>{
        e.preventDefault();const s=state();error('experience',s.experience?'':l.experienceError);error('jobs',s.jobs.length?'':l.jobsError);
        if(!s.experience||!s.jobs.length){form.querySelector(!s.experience?'[name=experience]':'[name=job]').focus();return;}
        submitted=true;update();result.focus({preventScroll:true});result.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      });
      form.addEventListener('reset',()=>{submitted=false;requestAnimationFrame(()=>{update();error('experience','');error('jobs','');result.innerHTML=`<div class="rwkf-placeholder"><h3>${esc(l.waiting)}</h3><p>${esc(l.waitingHint)}</p></div>`;app.querySelectorAll('[data-kit]').forEach(e=>e.classList.remove('is-recommended'));form.querySelector('[name=experience]').focus();});});
      update();
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
